<a 
    style="font-size: 18px;color: rgb(116, 113, 113);" 
    class="icon icon-trash" 
    (click)="onClick_deleteFavoriteItem()"
>